export default () => ({
  inputRoot: {
    height: '30px',
    borderRadius: '8px',
    color: '#646464',
    fontFamily: 'Nunito',
    fontSize: '14px',
    '& input': {
      height: '7px',
      fontSize: '14px',
      paddingLeft: '12px !important',
    },
    '& input::placeholder': {
      color: '#757575',
      opacity: 1,
    },
    '& fieldset': {
      borderWidth: '1px !important',
      borderColor: '#003F74 !important',
    },
  },
  clearAllButtonRoot: {
    margin: 'auto',
  },
  customButton: {
    borderRadius: '9px',
    maxWidth: '30px',
    maxHeight: '30px',
    minWidth: '30px',
    minHeight: '30px',
    marginTop: '0px',
    fontSize: 9,
    textTransform: 'none',
    color: '#3d4241',
    marginLeft: '0px',
    border: '1px solid #60797B',
    '&:hover': {
      backgroundColor: '#60797B',
      color: 'white',
    },
  },
  buttonContainer: {
    padding: '7px 6px 7px 6px',
    position: 'absolute',
    top: '-45px',
  },
  resetText: {
    marginTop: '0px',
    marginLeft: '8px',
    color: '#60797B',
    fontSize: 14,
  },
  resetTextDisabled: {
    marginTop: '0px',
    marginLeft: '8px',
    color: '#627B7A',
    fontSize: 14,
  },
  cases: {
    height: '5px',
  },
  Cases: {
    height: '5px',
    margin: '0px',
    backgroundColor: '#0d8461',
  },
  Samples: {
    height: '5px',
    margin: '0px',
    backgroundColor: '#10beff',
  },
  Files: {
    height: '5px',
    margin: '0px',
    backgroundColor: '#e636e4',
  },
  sectionSummaryText: {
    fontSize: '16px',
    flexShrink: '0',
    fontFamily: 'Poppins',
    fontWeight: 400,
    lineHeight: '18px',
    marginLeft: '5px',
    textTransform: 'none',
    letterSpacing: '-0.02em',
  },
  dropDownIconSubSection: {
    marginLeft: '0px',
    fill: '#000000',
  },
  customExpansionPanelSummaryRoot: {
    height: '42px',
    padding: '0',
    flexDirection: 'row-reverse',
    paddingLeft: 0,
    borderBottom: '1px solid #D2D2D2',
  },
  sortGroup: {
    padding: '10px',
  },
  sectionSummaryTextContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    zIndex: 2,
    fontFamily: 'Poppins',
    fontSize: 18.5,
    fontWeight: 500,
    marginLeft: 3,
    color: '#000000',
    letterSpacing: '-0.02em',
  },
  CasesCheckbox: {
    color: '#10A075',
  },
  CasesCheckedIcon: {
    color: '#10A075',
  },
  checkboxRoot: {
    marginLeft: '5px',
    height: 12,
  },
  panelDetailText: {
    color: '#323232',
    fontFamily: 'Nunito',
    fontSize: '14px',
    fontWeight: '200',
  },
  panelSubjectText: {
    color: '#323232',
    fontFamily: 'Nunito',
    fontSize: '14px',
    marginRight: '0px',
  },
  activeFacetDiagnosis: {
    color: '#357288',
    fontWeight: 600,
  },
  activeFacetDemographics: {
    color: '#8C3F8D',
    fontWeight: 600,
  },
  activeFacetTreatment: {
    color: '#4555AB',
    fontWeight: 600,
  },
  activeFacetTreatmentresponse: {
    color: '#E9B34A',
    fontWeight: 600,
  },
  activeFacetSurvival: {
    color: '#CD5C4E',
    fontWeight: 600,
  },
  activeFacetSamples: {
    color: '#1F6BBF',
    fontWeight: 600,
  },
  activeFacetDatacategory: {
    color: '#60C4A1',
    fontWeight: 600,
  },
  activeFacetStudy: {
    color: '#357288',
    fontWeight: 600,
  },
  activeFacetSequencinglibrary: {
    color: '#8C3F8D',
    fontWeight: 600,
  },
  searchContainer: {
    margin: '0 2px',
    marginTop: '-15px',
    paddingTop: '15px',
    marginRight: '6px',
    marginLeft: '10px',
    paddingBottom: '15px',
  },
  findCaseButton: {
    // marginLeft: '105px',
    backgroundColor: '#974599',
    boxSizing: 'border-box',
    height: 30,
    width: 40,
    border: '1.25px solid #974599',
    cursor: 'pointer',
    borderRadius: 11,
    display: 'flex',
    marginRight: 6,
    justifyContent: 'center',
    alignItems: 'center',
  },
  findCaseIcon: {
    width: 17,
    height: 17,
  },
  uploadButton: {
    boxSizing: 'border-box',
    fontWeight: '400',
    height: 32,
    width: '100%',
    // display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: '#974599',
    color: '#fff',
    // border: '1px solid #0D8461',
    borderRadius: 10,
    fontFamily: 'Lato',
    fontSize: 11,
    boxShadow: 'none',
    paddingLeft: 16,
    paddingRight: 12,
    '&:hover': {
      backgroundColor: '#974599',
    },
  },
  iconSpan: {
    marginTop: '5.2px',
  },
  uploadIcon: {
    height: 19,
    width: 19,
  },
  customListPadding: {
    paddingTop: 8,
  },
  customDivider: {
    backgroundColor: '#B1B1B1',
    height: '2px',
    marginLeft: 0,
    marginRight: 0,
    // marginBottom: 6,
  },
  searchResultDetailText: {
    color: '#5E3F14',
    fontFamily: 'Open Sans',
    fontSize: 11,
    fontWeight: '400',
    fontStyle: 'normal',
  },
});
